'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_Seq$() {
  $n_Lcom_raquo_laminar_Seq$ = this;
  $j_java$002elang$002e$002dObject.$m_sci_Nil$();
}
export { $c_Lcom_raquo_laminar_Seq$ as $c_Lcom_raquo_laminar_Seq$ };
$p = $c_Lcom_raquo_laminar_Seq$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_Seq$;
/** @constructor */
function $h_Lcom_raquo_laminar_Seq$() {
}
export { $h_Lcom_raquo_laminar_Seq$ as $h_Lcom_raquo_laminar_Seq$ };
$h_Lcom_raquo_laminar_Seq$.prototype = $p;
var $d_Lcom_raquo_laminar_Seq$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_Seq$, "com.raquo.laminar.Seq$", ({
  hw: 1
}));
export { $d_Lcom_raquo_laminar_Seq$ as $d_Lcom_raquo_laminar_Seq$ };
var $n_Lcom_raquo_laminar_Seq$;
function $m_Lcom_raquo_laminar_Seq$() {
  if ((!$n_Lcom_raquo_laminar_Seq$)) {
    $n_Lcom_raquo_laminar_Seq$ = new $c_Lcom_raquo_laminar_Seq$();
  }
  return $n_Lcom_raquo_laminar_Seq$;
}
export { $m_Lcom_raquo_laminar_Seq$ as $m_Lcom_raquo_laminar_Seq$ };
